module.exports = __webpack_public_path__ + "img/img2.988bff1c.png";